import { Button, Icon, IconProps, SvgIconType } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { EvaluationSteps } from '~valuation/enums';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import { FormType } from '~valuation/utils/addFormSchema';
import { useTranslation } from 'react-i18next';

const optionsData: {
  id: number;
  title: string;
  label: string;
  whereSavedText: string;
  type: ValuationTypeEnum;
  iconName: IconProps['name'];
}[] = [
  {
    id: 1,
    title: 'valuationGoalIOwnProperty',
    label: 'valuationGoalSavedPortfolio',
    whereSavedText: 'valuationGoalSavedPortfolioWhere',
    type: ValuationTypeEnum.PORTFOLIO,
    iconName: 'listing',
  },
  {
    id: 2,
    title: 'valuationGoalCheckPrice',
    label: 'valuationGoalSavedMyValuations',
    whereSavedText: 'valuationGoalSavedMyValuationsWhere',
    type: ValuationTypeEnum.ESTIMATION,
    iconName: 'price-level',
  },
];

const EvaluationGoalStep = ({
  setActiveStep,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation('app');
  const { trigger, setValue, watch } = useFormContext<FormType>();
  const selectedClassNames = 'bg-blue_light_2 text-blue border-blue_light_2';
  const unSelectedClassNames = 'bg-white text-gray__dark_2 border-gray';
  const valuationType = watch('type');

  const handleNext = async () => {
    const valid = await trigger(['type']);

    if (!valid) return;

    setActiveStep(EvaluationSteps.LOCATION);
  };

  return (
    <div className="flex flex-col gap-3x md:gap-5x">
      <div className="flex flex-col gap-3x px-2x md:px-0">
        <p className="text-lg text-title_3 text-black">
          {t('valuationGoalSelect')}
        </p>
        <div className="flex flex-col gap-2x md:gap-3x">
          {optionsData.map((option) => (
            <div key={option.id} className="flex flex-col gap-1.5x">
              <div
                className={`${valuationType === option.type ? selectedClassNames : unSelectedClassNames} flex gap-x border cursor-pointer items-center py-1.5x px-2x md:p-2x rounded-[8px] `}
                onClick={() => setValue('type', option.type)}
              >
                <Icon name={option.iconName as SvgIconType} size="32" />
                <p className="text-body_1">{t(option.title)}</p>
              </div>
              <div className="flex gap-1">
                <div className="flex justify-center items-center pt-2 md:pt-0">
                  <span className="w-[8px] h-[8px] rounded bg-orange_light_1 self-start md:self-center"></span>
                </div>
                <p className="text-gray__dark_1 text-caption md:gap-1 flex flex-wrap self-start md:self-center">
                  <span>{t(option.label)}</span>
                  <span className="text-link">{t(option.whereSavedText)}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex pt-3x px-2x md:px-3x border-t border-gray w-full">
        <Button
          variant="primary"
          size="medium"
          disabled={!valuationType}
          className="text-link w-full"
          onClick={() => handleNext()}
        >
          {t('next')}
        </Button>
      </div>
    </div>
  );
};

export default EvaluationGoalStep;
